export default __webpack_public_path__ + "assets/bb2bac21f637a5d1403ce326a5036b7a.png";